<template>
  <el-dialog
    title="转外销"
    :visible.sync="dialogVisible"
    width="40%"
    class="tranExtSalesDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="tranExtSalesForm" :rules="rules" label-width="130px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="线索名称" prop="leadName">
            <el-input v-model="formData.leadName" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="外销负责人" prop="userId">
            <el-select
              v-model="formData.userId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="userLoading"
            >
              <el-option v-for="(item, index) in userList" :key="index" :label="item.userName" :value="item.userId" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { waitingProcessingApi } from '../../service';

  export default {
    data () {
      return {
        rules: {
          leadName: [
            { required: true, message: '请输入线索名称', trigger: 'blur' }
          ],
          userId: [
            { required: true, message: '请选择负责人', trigger: 'change' }
          ]
        },
        dialogVisible: false,
        formData: {},
        userList: [],
        userLoading: false
      };
    },
    props: {
      tranExtSalesShow: {
        type: Boolean,
        default: false
      },
      rowData: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    watch: {
      tranExtSalesShow (val) {
        if (val) {
          this.remoteMethod('');
          this.$set(this.formData, 'leadName', this.rowData.leadName);
        }
        this.$nextTick(() => {
          this.$refs.tranExtSalesForm.clearValidate();
        });
        this.dialogVisible = val;
      }
    },
    methods: {
      remoteMethod (query) {
        this.userLoading = true;
        waitingProcessingApi.getOutSalerList(this.rowData.city, this.rowData.industry, query).then(res => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              this.userList = res.data;
            } else {
              this.userList = [];
            }
          }
          this.userLoading = false;
        });
      },
      submitHandlen () {
        this.$refs['tranExtSalesForm'].validate((valid) => {
          if (valid) {
            let params = {
              leadIdList: [this.rowData.leadId],
              ...this.formData
            };
            this.$emit('submitHandle', params);
          }
        });
      },
      dialogCloseHandle () {
        this.$emit('dialogCloseHandle');
      }
    }
  };
</script>

<style lang="scss" scoped>
  .tranExtSalesDialog{
    ::v-deep.el-dialog{
      margin-top: 20vh!important;
      .el-dialog__body{
        min-height: 240px;
      }
    }
  }
</style>
